export default __webpack_public_path__ + "static/media/typetractor.41b78bf2.svg";